import {
    FormControl,
    FormHelperText,
    InputLabel,
    OutlinedInput,
    useTheme
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import * as PropTypes from "prop-types";
import ImageList from "../ImageList";
import Box from "../Box";
import imageIO from "../../core/imageIO";
import lang from "../../core/lang";
import downloader from "../../core/downloader";
import React, {useEffect, useState} from "react";
import i18n from "../../core/i18n";
import clsx from "clsx";
import FileDrop from "../FileDrop";
import Button from "../Button";
import useDimension from "../../hook/useDimension";
import fileIO, {FileDescriptor} from "../../core/fileIO";
import {unstable_batchedUpdates} from "react-dom";
import logger from "../../core/logger";
import usePrompt from "../../hook/usePrompt";
import numeral from "../../core/numeral";
import time from "../../core/time";
import {Icon} from "@iconify/react";
import outlineFolder from "@iconify/icons-ic/outline-folder"
import roundDownload from "@iconify/icons-ic/round-download"
import outlineFolderZip from "@iconify/icons-ic/outline-folder-zip"
import roundClose from "@iconify/icons-ic/round-close"

const MAX_FILE_SIZE_ERROR = 'The file size exceeds the limit of ${size} bytes: ${name}.';
const ZERO_FILE_SIZE_ERROR = 'The file size can not be zero: ${name}.';
const MAX_TOTAL_FILE_SIZE_ERROR = 'The total size of all files exceeds the limit of ${size} bytes.';

const UNKNOWN_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA5gAAAOYBAMAAABC5kGOAAAAGFBMVEXm5+f/WVn////b2dnMy8u5ubmjo6P6m5tRuAeAAAAgAElEQVR42uydzZLiOgyFIekqthioyjbArWIbmAXb7lW/Dg5Tlde/dMPM0H8QYcmWnOPVPTN1J1K+SLYjK4xW51GPzgPSssSdAExIwIQETEjABExIwIQETEjAhARMwIQETMikMEtI4xKPdWbyNIrLH0EaloAJmJCACQmYkIAJmJCACQmYkIAJCZiACWkZZglpTV7BbPBYG5cN0mx+aRbFwIwk7gRgQgImJGBCAiZgQgImJGBCAiYkYAImpEWYDaRxiccaaRYSXWCQOAMECZiACQmYkIAJCZiQgAmYkIAJCZiQgAlZoAssD9n8g9ngsUaahdQGE8VAFKchARMSMCEBEzAhARMSMCEBExIwARMSMCGTwmwgjUs81kizkOgCg0RxGhIwARMSMCEBExIwIQETMCEBExIwIQETskAX2AhdYJBIs5DCMFEMRHEaEjAhARMSMAETEjAhAVNW1qdN2OXPy19ve7G6BkyT8tfra9d537nLOP1n1/0+jADTlqz33V+GX0ZVdceiXgGmflmX+585Xo3ud7MCTM2yKDvveo+qa+psYTYG5QdvXgkkLzyPP94Yi3fD+LP4z5s1meSF5w5pVpmcPIjyHechp/Wf9YJe+eoCxxHFaR2yDkb5jrMAzOSy3jumcSwAM63ce8c2TnMnYKaTE0aU551KAZhJZDHqHPvonmvAjC951j3fTZ2AGVuuvRMaVQOYceXeCY4jYMaU3omOOWBGk6Uwy1OqLQAzjty4CKPNA6b2vqe9izKO3942dIFxytq7SOOUar/eNqRZRrmOxvKt0mktzdoq2e1d1HFAcVpOvrrI4wiYUnLrXBKagMkvvUswKsCUkElYvtMETG6ZiOUbTcBklslYnmgCJq9MyPK9KAaYfDIpyxNNwOSTiVn+iU3AZJDJWV5oAma4VMDynGktwWxUSh0snVugCyxYFp1TMn4jzQbKYu/UjKOJxaLiGt3GKRoHFKdD5NqpGs+A+bgc6WJ52W4C5kPSO200AfNRuXXqxgIwH5MTp3AcAfMRqZLl25IWMMmy9DphVg1gkqVSln/7UACzv3xxasccMGly4hSPFjApsnSqR2EGpobOJq8bZqXpXo2Ud4EtnfIxQ5rtKzdO/WhX6AIzdE7E4ikShTC3zsCYA2YfOXEmxgEw78vS24BZNYB5V744I2MBmPfkxJkZLWDekd4OzAowb8rVizM05oB5S26cqdEC5g3pbcGsAPNnaSwwz+9oAfNbWTtzo0AX2A9yaw/mHF1g38uNMzhapFldH4cJWwOhCyz2Z9cFEy2K01/l2hkdO8C0dLbSyslLNTA3zuxoAfOT9HZhVoD5UU6csx6agGnkoGyf0ATMwuhL2W9CEzCLDALzEpqAeZZjZ3zMAPOvdOZHAZgXObYPc4YusLOsncshNNEFVuQRmM5NkWbfZBaBeQpNdIHVRvqE+r9vH3Rxeu0yGQVgigZm1f2+/NDeav2r2b92neisOXiYpRzI5tvrjjovGppDhikUmMeb15XhORs8TJGgbO9ed91JheaAYS4FUO56mSHwy6qzgcP0Agm2rxnsOKthw2SvY3YFwYyiZE627aBhMgdm9VzTzKh5585qyDCZA/N384BHe+bQHCxM1sCsjsVDZtSeNTSH2gXGGpjVqHj0Tuw5Q3OoXWCcLwymIVbxHfScDzXNcr4wOIRZxZcjioF2gTEG5jHUKjaaKZvCUsL0rCwDrWKjOUyYfBPVgcOqDd/uZIAwPWtchlu1YdudDA/mhDcuGaxi2qHsBgiTa/lz5LPKM+1OBgeT64RBpa/lZXgwx3wzFJ9VPDvf2eBg8gTB++9yaev5rYYGc8O42FA3k7cDg8mz/GnZjWT5Qvx8WDB5Jqcpi1Ul/6uMYjWkLrAN39xExnWnUeqFKWMMpwvM8yXZ7y4U4tFa3RpbeZplCcyjkJETnoXZYLrAtixPv+LDLPMBFad5diWaj5kNB+aEZ8LUfAD0MBiYnmeJIWYkwxpoMRiYTDs5OSMZXhw3A4HJcKsOskb+x2ThAGB6liQraiSXidnDLFlWP7JGTngmgvxhjrmeekkjw0NzNgiY4fdpJ2/kxMITlx5meJaN8sUdroNdecMc21j1j5nybN5dYMFZdipk5McbUzIuubPtAgt+8VlJGVlyv6Zqs0+zy/DAtPICeRa/ghG57OYZklccmx1DDsm7OF1y5K44NocvgZ4zhznmWFVYOQ4xzRym51hURLKZJc9mDLNkWe5HsplhR5w1zDHHAjEWTJY8mzFMzxGY0Q6+ceTZjGHyVCJi2Rz+3iBnmKEb8cgNMcEvONwhY5hblsCMBjP8YNciY5g8dUxLTaT5wgzMsovCHsxDYphyzUqBG5Pnn71hNPL6Xw5/2T6NcmNTdIH5wHX+V/MFjLz+l5/CNye5ptnS0srwLLkOj+TXBbYM3ZdErw0yvNGbZlqc9qH7kvgww3eaVaYwgw8Vx4fJ0EKUJ8yw99aJfpiAo7kvR5iB80+bBGb4TnOeJczwikkCmGyTZl4wgz/9M7UJ861CnR3M8FJvkQDmmmvSzAsmQ/NXApgMK6B5hjA928IwKkzPNGlmBZPjY8FVAphjpkkzK5gsHxicxoe5ZEoosWHKdSeNuH6R5svK8O51Q5vCNkyTZpT7HOspZ2EZc/65NIVxfBcxtzTL9X39Q+w0u2LKJ9FsNnGgOHqvyaWmz7AKj9XsFAvmkgnmYzemCHCBAeY0M5ieC6Yrel+3Lruuehvd669kx0P/pJOMYDL+VGbPX6Wpf334afDukBAm4QG0AJPzB4nbPnn16cuvvHdFmlP4l7khI5hjxxma96/7+t3/1yaDOc0KpmeE6WaPnul8aPH0X7ypwQhMxzqa29dde850x7JDzgnmhhfm4uZ1n26uROguxJrnrcBc8sK8+bvEdeh8+1lyTBGzjGB6ZpjVjevevlZLf+HgIy3ahgrzXIh46O3EM9mFF8sw+ZuV1o59ND9cd9zrMSA1hbEU73ai9zlmF9iGH+bi4ZXWgeoCC8x2dLN30FCaHfPDfGPy9ULrvhma4gLnGYkMusC8AMzq4QsVRBdYfx7SfnHaSYzD1wv1S4izFDBdLjCfRGB+PRM9IQRJdJi7TGBOZGDOP1+obzZvaS7wlO/aTGBuZWB+PhPdO4JmKWBOM4HphWB+OhNNWoxQXHCMKyDzMJ3U+HAmmrD/KRLAdHnAfBKDeX0mek2bv+LD3GUBcyIH8+pMtKfNXxQXPOMKyDrMrRzMf2eiN8T5Kz7MWRYwvRMOTfINTwKzygKmkxzHh9p7igQwXQ5dYGtRmG9rIPr9bq9bg+66wASzyKALbCMLc/52oQ15/koQmW0GaXYpC/O0BqLf7mkKmDN5mOJ1thdhmNWK/vK3orhQMMFc2D8DVDjp0dLfF5Jgsj2OGRzoEofp9k4W5hYwL/LJaRxNCpgH8zCXKmEmSbOteZhjROZ1kcc2TK8S5iHBalb+FxilYRb2YY4Ak+kHM3OKTGcd5sQhMq+Xs6ZhbhCZH5azpmFuEZkfigKGu8Dk38wywLz702BsMBe2u8CULmZpkclXE6htp1kHmB+Ws5a7wGqlMNvoJ9ovhw0sF6eVLmbdLg3MFjAFRhG9CywDmEulMFdpYE5Nw9wCZj4wle5MKopHy0TXBUyBmzoGzHepdWdCOjfL+UAWgJkPzJ1hmFp3Jm0qmC1g8m8zU73EmhmGOVYKk+LR2iZM/u4kpTC/78/8wSPW7DLvf111XWBKdyaXNvgy/hvJqv911aVZpTBJH6jgzS6Gu8CUTpnPFI94H0i7xWml5yxpRx55Ye7MwlR6znJO8ahkz/CAybr+oXjE7MPMLEylOxPSAbYxYKqGSfJoC5hn6dVm2f4eMfswB0zWcUi5u6rMwtSbZdOt4QCTNTbSTvtWYZZ6s2xvj7aAeZY6t5lN2uTSGu0Cm+jNsn1dKAVh2uoCU7nNnCZOLjOjaXapdi3b24WtLZiC9UyNMIm/yeWlMoO54vRWIcwDyQWBo6ILozA1vgBqSC4InC6sAJOvlElyYQuYf6TKNwYkFyQexxow2cKC4oLIGW6bkVlrzLIkF0RWcA1gst1IigseMAWXggyLD4ILpdC0DZhc95HgwgQwFcMkuvAiYsTMJEx1b/OmRBecZZiM7UgqYT6T2q+kKnhTc11gjUKYFdGjl0gwTaRZbeVM6spDyIyFyS4wZa9mK6ILUuu3ucnitDKY1KrwVvShAsygUdBcqB1gqoVJPUq+AcxrqSswqY2Rco8iYAbHA9EFwSoBYAbv7oguLAHzWuqqgDVEFwQn/AIwQ6vSNBckiwSAGfz2h+bCGDA/SE0VsIrogmgzYguYoa9lSS5MsoHJ1J2kCebtL/18/VsfA6alLjBFMOffuv6zC7K9iEizYfsSogtbqzDFCmt6YFZUF4TLNwaL03pq0y3RhaWsOQeDMPU0wVNdEC73TBGZoVXp/i5Izw+IzOCqdH8Xtg6RGaXr5pF9CdEF8deQc8AMrUr3dmEMmHphUl3wgKkW5pTogvz2GDAff/tDdMEDplqYFdGFtQPMr7J4UVL8UvftojgwebvAvAqY97qbErTuV9a6wE6RqQLmxy9SlCo61xYG58wXHVk2/Yd/7kWmhS4wDQugSmMNdm6wOK0hzc402lwZhKkhMguazXHq6YjMKDGwdYhMtZFJPG0T6dg2IvPxSmZ/m5cOkak2MqltrR6RqTcyWx1fpEBk8lUye9sc6+lDZD6cZXvbvHaITL2R2dJsHjtEpt7IVPMRg5SRydSdNNaRZVc9HVxGM2xKsEpLF9hYR5Zd9XTQR4fZGEqzqWHu1HzEoF9kqu4CS7wAqmg2R5zhcaCLXv0i2bx2gKkY5o5k8xIwFXeBVTSbY+6jLDYOpe0Cm5Nsjtrljf5M+saEYnPUKeEAmORSpp6PGCDNBr/+Idgc91saFiMz6ddGZpo+YvB5BkBkkt/l9bc58icbW0QmuWLS3+YlYGqOzIpkc+RiXZw5k7cLbJN2yuzR9nWRa5cWpoEusP/ZO7PdxnUkDNNSAN96CcBbWR7At/QC5DaNbqBfx3IO4NcfLXaceBPZUVVx+Zk+wPyTSC7zUxUplkoU9cyDVdnXSTJH2Zv95UIIs7nskOnRGymumgmwCkzwtd7axWb2CJIN28+xb4Uxd7F5JBE2ANNtwczW5gowvYZpHGzmn6cBplNzsZk9ymKXPvf5j63NFWB6DXPiYCT/DRRgui+xWBo5Bkwr+UsK5rvXRoa55/RadDLr7SxtEiTMkRBL7WDkkt+8GWASwVzEDnOoPaoWQjAnDt9oLQgzpL3AxPaP2jsYKZSeCy/Mjv2HuYwMJl1iTcozM3sjR2LXWmDJaSWU0NQORkrcPZkgYZb+wxTLAgDm4DBFnmwpwoQpszjrsJHJGDA9h7m3N1Ji/qMVYLpO/a2MrADTWo4898xMwrx5oDBl1vMc9osSXGwETLupv7WRIvOfWaAwZZaACmsjRezbA6bDBMMe5jpmmMNWgSmZAgVtb6TIbPvdsjbNoyqw7kMkOuvV2kiZ3cpUoGFWBObc3shpdDDp8pkycWxmbaTMKEDRzwzJad9hrgDTRf4CzEdpgPBgSqznHayNFFnTmAEmYMrDHHsNU2TN4ACYDm1jbWQFmE7Sa88UgbkBzHg8MwsXZiXRWz7D1IDp0uyNnAKmk1x7DFNkNW/ODXPA6qSRH2H2fs2UyAIQTT/TV4HJPJhx77veNVKiaGi6DzjMjj0OszHCpMxnSoxLxtZIkdqEjKafOZLTEuOSNcwXCZhlyDD5703effZMDZhuo5LPnhk2zBE883tqOmSYK3jm9ywAYJLAzAHTUS7hmd9TOiHD5L/RPPjsmVnQMPmnszOPYeoSMN0mjIBJ9iEjb2EKPAYxYYQ5dBWYyHTWvtaEf0Fj9qTIyuMqsFwMprY1suCHebjqnNDC7NIrmEXRluJmWZFvtxKTWeIwS5rPFHhAT1+bUQOs1daomt/bsWn8LnlqlP1Mn5yWqGit/a6rpa0//e2txae1nnrQdBE4TP5KsJbeUU+rqW/tNXTPVKMp2uddU+gwV4B4WTYOHWYOiOdmgoepAPHLZDZ0mBUonu+Aw4e5BsbzQmP4MBfAeJnMhg5zDIyXyWzoMDNgvMx/2GEOWJ0ks6Dn8fyHqJ9ZqsBaiTWgz8W88MMsZkCX+Q8xTOJ8Zi0xA2rbgbqf6ZPTtcSCXpeaiwIm1oAAM7b1n0hgYjo7bZ/MiwImZkCf85/wYWIGNHXab9drmBg03bZoBUzAZIKJGZDLFq2ew8QMyGWLVs9hys6A9NFkRbHc/pWM9oYbpqGSklkwvflSznSUy39x9DOLZ4pscNK1j+9W5UKX1auKJsyKDZra3FglY8qEp5/p85ml0OY+p/uBa6tEaG5Kjn7mgVnKsfRjg44yJphrufv0W6v4ac6jgrmQW3O5Y9WbQMokIpgCg+bhiVUVvy0RweQfND+eWbWsuIfMqGBy+4J+btUbe8SPCSb3oPnuU23aLDKYzK+QmfdZpbiH75hgMg+axqvn7MvYYFbMjtlnVcE7ZMYFc8HsmL1WrVmHTCmYQ1eBleyD5lxZWLVkHTJL0n5mqQL7embOtL6VkRXnkFnSV9sxhlnGQVPbWcW1KjUv2cIsW55twRvWLKxiy2XSdix3cpr3VV2WVmVrxqAfGUy2OGtdosOUClMxwlyzRlkLq3henfEaJUyuOGtf1bHmGzJjg8l0Y+dQCMASZ02UMJkGTZdCAL4hMzqYPGvbLoUADJfXPFKYPIOmi1UMl9c+UpgsK3raxSqGQbOIFSbH7NHt2XH6aytamBwregcnq8gHzZkUTLrqpNNnciSEzZPvemsV+aCZ9ZsRWhXY+TMZZo/3tyR7ZCT1U3q6jDbMMsRZ7WYV9QxoxguTLZ/JM3t0LQQgvzHh6Vju5DTThMOvlLmKGSb5zcnBK5jzqGGSx9mNo1Vr4igbM0zyu3RXq0bEUTZqmGvPYJKGitfIYRLHWe0VzH3kMHPPYJJmckzkMLNf5JlpJ6soLy6tIodJHGdnPsHcRw8z8wumIo6ykcNc+wWzoo2y0jBzMtl+0Iof5hOrCN/RuOfrWJYqsLuSeDXPrd6KEKZS8YdZ0hW0g6tVdDBfBWCy5jNbOSaeQHpSAXNg71glAFN5BZMsTpRpwFyn4JnzRGCOU/DMfSIwVQKeqVUiMPMEYM4VwuyPF9p9gfmeCsxR/DC1AsxoYE6SgbmOH6ZKBibh441zP2C+pgOT+BEqJ6toapn28jANkyR+UsOpNm1JFWWf1C8FXgX2TeZ8MPtr01ZUI3ciYZb0KSDlw0vgjBRM/nwm6aMGPjw3y/caS/nk9IL4UQPxWpNDQjBHPsEkuDPRZUIwK0qYHtRnzlKCScnSeT88AhMywBwuxrlYRbBmMCkTgkn8/hg3q1ZU059EYBK/Qe8gvNuKzgBTCObwdyb7pGAuaGFOhHcoU0nBHE2JZ0AOVg0/fk/SglnRwpxmDlYNH/KVZzCJq8CoYR4cvtHgQ+bTF//EVQVmyIttT/mn3NIqinzJbR/HG2bJ3wSk7a1aUXy2ZJjlTrvRv6h9Y23ViOKj2ROYgslpepgza6uGHr51mRjMBTlMbWvV4InpQ2owR+QwT2mLfqtGJFdRSjCrKVOc7beqonBMwBTxkLFUeAfM4ccuGsdMCSbHbhjd43F9Vr3QOGZKMHn2XTxYWPVr6NxXejB5Nneb91s1+IipAJPONZ9bNfjYvU8Q5ogHpuZeiNLKM5gcVWBMMGvXfF5+Nbxj2u9BFk0VWDXlck3WaK+V2x5kcYRZLpjTyTMzBp9TS1XXilaB5VO29uz51aEvqblQAlM2Oc0I80mZwJrkwkkO5pgR5sNqrMEnYZMSMHlo3pjxRhQDkoM5mrLSzO6YMTzLSZkmzPWUl6a5KfsimE6XicKspsztmGVfzRgTGHAATDbnPP5WRVa32ivfKqpYniTMqUTTx67RnH2fKsx8Gl17VanCHMcH0wBmNG2i/IZJWAU2io3l8+KSnEtKVIHFB3OvRMu+RMNsFRnLuXBcFa0Ciw2mFwlMqeR0ZCwPKcMs4mLpQT2CIMxVXDAzwIxnJlsmDXMR1y1m2jCjus00icOM6c5krwAznmRJ6jDjWpNNG2YRVZBNHKb1nYl+9/wm5kN5D5O6WGllH8P8Hl51X6caFX0VmOVt5kdW/3HhM01z8wXz5MLsyC7EFm4xWWjA9DLM8qXdrN40+3E+NnvzdsD0J4Epl5y2gbn3P5OtFWCWFg/NavPtuUwvaWoDmLXsfWj2Q7CY07q9K8Cs5ar3kr8+duzn5Acw+2Dqe8d6R9OzJ7jkYI7611RujvUsafaqALOT6ydu+XAzEq8mQVoBZtee3JkcnxxbeTWRBcyTrJ7dXD48dukPzY0CzB6YevP82KUvfnkoAfMs8571u4fHerJKeyhDhElUrPS/u5f73sLelScs+zs1F5LsVWDj3vW7h8d6QHN/30iTaJgd96/fPZRvPvhlAGGWLc+2uL25tD+VsG9++JzAlEhOXy/muO3PM/aAJWB+yupe4AqiTuVQAOYzmNq96mYlN14C5rW8fv7O+VQrsbkPYF7J/GoM+odTraTmsYB5Jcc3z9+5n2rFv067KQHzCczj5t9P9cJMs1s3Bsxreboz0R/ZT07F+5DX+YWVgHkl16fu+empjnwsX00JmHdldVrh/OmpCralvY8A6MnBbEegn5+KZ+DURgUNk646qb3N1P9WM3XnLoeBpva0zsuLKrD8XHngfOy9AqsxQ4hVCmH2Ecxh35pD/GSQUWHC9D1H90hWlHckwfUGf+HQoJIu1O4LBZjcsjjSuGWYvRE4TJUNP3KeFqgAU0KOq2FRqkIBppgcchehj6wMuzdCh9ngHAxlCZjiMj8OhBIwfZD535+h/G8T9NePC2bd/n3s1P9F8PXjglm75z9FW/0eydePC2YtXd1T78O+F+mHSbgXmPnBsXayGB/tSWbu3ZZ7Kc0Fpgnh4nMwcnfsdVB9NMN/LsIshSwytft7fIC0Oh63qozq+37CDDFlZyWbL7ndHY9vx0vbbuP9vkV03+ZaZp+pyXYT8di/b9wwE5PoCcCEBExIwIQETMCEBExIwIQETMg+mCY8mQ/XE9enCrA34ro0c3gmYlRMMrZ8ZqoSMAETEjAhARMSMAETEjAhARMSMCEBEzAhQ4aZQ4YmzQWmwWWNMAvpG0wkA5GchgRMSMCEBEzAhARMSMCEBExIwARMSMCEFIVpIAOXuKwRZiFRBQaJ5DQkYAImJGBCAiYkYEICJmBCAiYkYEICJmSGKjCFKjBIhFlIYphIBiI5DQmYkIAJCZiACQmYkIAJCZiQgAmYkIAJKQrTQAYucVkjzEKiCgwSyWlIwARMSMCEBExIwIQETMCEBExIwIQETMgMVWAKVWCQCLOQxDCRDERyGhIwIQETEjABM3SZu0jA9EUum5tnk6syK5p/Km+bKrq2tJF5c2T937I5j/nyQTlgUsu8pZc3AJqWd7o4adO1rGuqU9sret9+25yqbs2x7Ynzzz9WLd0iMLae+16Nq+3UFtey80TT9X+xrFHl9U+migZJXqvm/ygarQq17ZrK2p+8U6b+RdH8vvvbzlPrY9uDLxdC68SmQ51ly84KwHSVLa56ZGtDZ1H3oFGd/7QO0/Fq+7/u8m0D4MRHnXG1bM+y/m3HMsvr/938K7q/Pv9xc2DWSXNC3XxQd+KTV5etFaa9iLLPmJwDZv8w2C4jF91Ypjrfa/2n8b0GZeNsp8nM2fc6X/t0xevf3pHF12Nrmsuvsv7jE9zW5VV9EbVw88aq5qoyDcr6iusW1AoDmGfZXeV3xz217IJh7V0q+wqkDaPPcXVyt/19kb+/SwvUrbFF89vmIsobsPVV1YXgXJ1G7lM0MX7BNGSyzxWb0akoa6CtK9b/Wlh1t13GvZbmDYFdjecsX3a73e8/u92n/FP/7HbNJKn+efnTyfNv679s/p1lw/lyqm9+e2abt7Jx1CZ612a2F1zZjqjNFy4efl+jYqoCu/rMdm7xf3KuNjdyWwkKkg8i2BcgRtr/BijlAqZ0glD3P8JjVTUpUjPeJF4j9uZpg8D0+GOkYnVXVzf9LC6qYMCDYWZTJFXuuuPP02U5e1yLMWNasF6WgY96eEofp9XiJv1Ly3lZPOPnMBH39J8pnWHBt55QT35O8F6xzQHCZd5KPFEWmzBO96R38/8RZgcLZUhApCLTohTo+Bd5L4EDfFhFJLLNJN/CUDwNCSpelljLUlde8msnENVedZBRCVdg69O7ARRP4vjDmNxX0Z5B+AVRON3FM9VR//LFdcy/13YbupuEas/tPLkbUewziKYl2qXrGAO9f0X5lz63CFM/sTIZDBdv3/TxpSvLQWXoIu6/OlkKd2+S+9AphY8T65vuhtCb7pCc73C//8HmtJPUkboHmAmKYXBSov09mN7PM74jPUjHCDkn4vwTfGbmwWkJy5r+vc0KnWtL2J//KNA5cf9VBsPgdd3vuNFkkhQw6yZUVdh5/fhfAxPwCcuB95r+R0WR7l414nXTK8olSgDwn3PPz0tYE2LhTY96WcO2hnQxVC5LSMt0LcyR6VW8vKYvxifmmS+FNeH8U2xZmzhJqPk1v8lpLu955C0gN99YKY3YrUjHt57lzH8EzBsk3yg7IF1pyVs3FdFQMaGnWOykToyKw4NnTLJ5Pl0fgEgIbwvzogeQ27rZ9yzrKnRtGbjYEKi9XjWoiTah/QnnSVVkSLzvd4iKvYrMSjMRkeiZt+9+fzBTyQjdSrfNMgy2bTdeqYgiA2CqNHmHIX7mBbjw2AX4shKeNcO1pWttl+k6lyteL8uQ/m2AmnAGXht/V7rCw7fxylTtJr2Z+VGetxsEoChEn+kQIureflMwKTm7wXJI56QXWHLcx1WvygF5FOG3BXNONN5Jo60AABHmSURBVMRDViAF94hWAWS9wPUPl+nH5SV+LH7yPM85CKdN8zb5C1GL8MrRhFGXYRe71QqYgfdLJ/J5osh1veXQ3wpMGAAkprOmUz85d4mr4OKrPINhVk3vh6uIwf73mYrnIweAd/isCL/BlsyUa1kBf2TLvNR1hy1fL7xVuk1BGCHYz3fxwktUQx1hPy7TI3lEo2Fk9k9ad+Sz+X3AhNxJ79icuZvsgM4VKvZ1XIWidSj47wJagm+ZlNsES7hnVwBjtxM+PHx+uG8MoIAwchkVitPH8YS6YC1kH2JLLQUsF6ml9aKEqdKQQhhzp0JUu10nZ38sHbiRVpdTDv3WYA6qJJEl89u/dcTymiTpyKSb59dM7rLpyUNoGto4swFzBTNIqdZYps9GXkRTsMYjrfMXxWNLqyPTNUG7A15pqELjNf8ifk6/d7aMGt7wvpuoSzix7dJ7fcDMkR0e+lJsIeC5O3ZMvzGYsj7M1RrV8jB19yhJeoqJi17F9vZ+VUWxlHCXCUM+VaET5NpxZXy2TasCHz480mfOV7G0wLvFHcDvjK3b2obovGtKRFgNTFl/bWIfJk80E1GzpGOmtVUPMeDUP30eaVX+BsxEn4+uQG+ar7OWoaRM3rjmA8xe9poeTJIaLORmVINXgZqDoYGZ+PSnKZ9ol33VkeCr0EsL/peX+wE0C7YHt0K9EcBUK04vUTcIZ7PsZ8XmOjUwhTJvYLfOaNQ4a9CZJ3xjT405CI/qNn5TMEcYb/LMedH1ZJzpFXZAxhm9ZhYfLCWrJ6ESz1tcxYMstWJDmIBAeuzbiV56/oSoUJFXJCz7lj7c03/RYDrs1U3ZM70G7Mv3iqd/srjZzgCe65gcdWHZe8Ca3lBTuMz+VZmDzEx4tlGX3h8u+oOug7b4hqfAejbkmTPzlI15PPlusFGRJDV+4+sYNU/c4yr8WcuzViQlQiVxVgVXoHKcdCJcCZRIhEXE4yAswNmufa+X+H58+SEsY81M/WRgSfgZEbCPFovteuMEcrMN6KsU6ibdoLfN26TQTv6XNYvQx8WTe/5FFFz3mafARnNfnQ3A9ewCDo0tMJlpTYeuTjjYw0m7BtONVsvnuKpwJ2Jt0p9g4h7ryJmp2KKHcJpXzJzxiNWrQt6+N+8LxuhTLun3KoWGa9TVm0P6hCIqdyTX2S8PLYVeYVdGvjEzRd07fL4qzN5yYYk8oFrE9NvF46Gx6WSx14onwZwfTJskKXBATJCuomIUncTEeMJVry5XZLSNNbRHy1t+s7AsRN2ki42c94bDaWXM83puT2SXhfXMpVKhc4vnM5W6TeL2c8LsZ3TS6FVym2kaStKnbQZ6mQNVI1GCKKiinOdiB+AyPbS1l8nWPa8aEN9D8S8uA9GuBN9OWcQwvFe/2tTzYjmgwvRHrj4ZbK1xii4rJ/qeVMaUlqyckzIACpcvMeCbNacxUqdkSYFjkzoGJjxVtvSdQy+jgAl5b1bMQjilexKYZpKKG9Gi7kbq7IcJ2L0JoB/EsiXsbplWWfc4o220KL+W+qXIM7kPIdA5rpriA5VQrqfbre1Qe2umk7LRdNCXgzlyuhUBNs83qa83WWdooKjz3gbOK2Yivv6wtoXPRl0w+ShHIOZkaXWE0uOelU4FyUfRJIJHG6njrk/GtmCJ6q2ViiULoU0OB2QQWqZ2g3SFBoxDgLK+mlJwmvXVABtzUzcKze/ATFrI3aDysnuRVzD1thelYmeJ2Gqag8Y04pOYuVQRDBYMkxSfYV0FUtZsypYVlr8A5QXXM2LzFzUVS3YpajAX1cTsn9InWM7diopzkg66DsKMmtweusnmhKlqvxhM+MajSKe40Y7UcXBHygcjVynyPPmGmaeX3YBp7tofWU5emdnq1k+8diXLnEKF5p69BBrEd2AGuRmmg+ZwDhsprfBqwRw6odm5Mml6zip+aZjVjJYN86fI6mzCrjCTcCpnnsyc+fkflnLKLq+8HjBT3DR+5Kd8J3jip2F51HoIspZ66LSY5B/mHZfteJJzETPnJZzMxOYVyHeDfhxgexnyBD/R/Fpm5v3EGZms0M5ZtrFipk2nP50FJm6+age/w8zTFt9yamSM/URmxibO2k+OxsydlSyZGej2P2TmBkHOuaVKAHHEy4bCajAdBVA5ziTvALOKX50zYRvTdnACEzk+q1l7+9Q/3l1zJpS8z1rQ34MpC+b07aJEZrxnZvy8MMsqMxuCyJlRzDwU7HPZKzCDSKjPgpm4px+sU9Rnd0wrjEHXnKnjTS+SjknNfhcBZMxUu4QnM9ph14m5ZJAnm5k5a+pnMalzFUDi6x/mwRRmRiZN1ZuxrTA+Kc4KuDZnZivf+ttrvDKTe08CyJ8DuprFVlyahssZFwmgTn1tnR3svxJMO4XcZ2Y+5+M9Spo2dzfQ7UphVmjOWQDpPMBiTtlFABlhN3N5MpjC8tha1/WIn0ZOtj6jfrSp2VhKk33NzMyuQVgqZjI1TpWatdLkQc50YiZMA7VPJCW/mpm9MXMo7ZKuZqaOGDCVaAS2cYCk/Sh1fNnlxkyVn0KzMHMnK4/9AZq/FFnPRTYIFdHPkkgV0hrCAzWrz642mFvUrE58ztK4TWkyiJlSs/QNnjUa9PLlOdOWTvMiPHhHD0g9aflZngIIdZeGWc/RC46tLpqOK8NzZhoEMmPfTmaqzbER4Npn/bCbJyzb1ooaZRRZVWcMzLTrCqaCixeapyiQS0JiTi0zB5dNA47s1V3Erz4FxsOn6TPPdqDZFFtWsyooZ3WuGweIQn6xhKPWVzA7T63CVQ57dvM2Kc1IA7W0Jo2t8cOB9cyRmi+JmzbH6c1G2fztEFg21hf1dhZNFmSFNw864vCkEmyyAczzdKD1CXXg/m/bef/OKTCHvy3Ag10vkq0Yy+sobtlx98JSgqA22un+0D7x1vtasemZSIvPbbEtnv43nu9x1L2vjyqevaI1Nkks8bxqnuB3RvV1wlp7sx4OFt7rCix97c2y6hhoZlZHodgzogM0Sm64rD56OyJ3OTH3RafAeLKLJ2ZqO09NE7sbnc2Zm8NZTDg6TCC3zJ7TOSCSbTSz8c6y0xCI6jN/IINGc9Yvlo81tnOVVCmeVSotiJnYgz84Xh+a42Ypsg7y0HHyE/+6Mj5CmSti8i9hNH/l5KtPgbk8pe2sxZoHZSfaBF3dz8yDsu4yjuf5QFbOVfrL0E89TJkFSSxjPfu2/YIKio3Bjh9FXLe7S4caqt6XL0cbfHZ+zmE9XHbi825YT+2SYTgnGdM1KFN9nxmgXn9uxd2yeTAM19MkaYfaoKzzvj78M602tK5w60NziGAlaHvujJGh+7bVgzv1QFeFT5UO99oPOOTsbLuZsXXHlAHVBrosZS/yAU4wMQOkTLAsb749vODkVKsh1sxEOx1htDPG2PifO+D+aWBWgyy9GpvO+gbjaOe84B7YTsUIO3Pn3WkS7WcjZLAjQs0E5Lru8hJCO7hj9f121MutmeCiM5ehp0q+bARNNOycuqzCK+ZoA8doYci+cbwdowXcgL45vOB5/o/Tebhf28t9PiN2/pUi9r5umm//jqOWOoJ508x2z9O0PCnE8yUWTxGKbZjfc5atgAkZ8WZTJPlw1v0IuwarVMyHUFOzYpdVFfvjQcy72crd5gi2Nde0mB14NPSz2dDPrI7PdQofO/FV0r6j7BMzeQBVp/MNS04ycjrvO41aunfmu/LRYadJUR3IvAxB55Eg1x4uQckCYPnYLkeDwtXzw0PfcxSuxgK2+E4QttmFSqhuZaI9Cy6MPT86rbDW55dYVf2vvTPMbVyHgbBg9SBGegGhzgECJDnBS+9/lWdxKFuO3W2TJk3cfj8W2EG63VZjUSTFGVeq6zwJ3IebbhdLXN13g46o35nJwpTVbxubZAw311XfQWsibUxrw3p5sFJmBTMN+d4vbfsvCmmuhJR+9mBTF/sq6h6qikVh7qiWWzVr4v3x9yI7qZpIw9/H+t/YtOJithXfveljCY+Jwoy/mRS3f2q76MF3nEbU79u2XmDGHKqkVc2TjHewxr+PCswmCFUQKx/yI7TemZYPbW0SrF+Lc+GQFZ8Hc+4ZpHULUfds3t32s0dX6yL1f3zPel48FDva1qdJ0bGwFZWvehixE/xwPD/n3TClU1p7Pijr2b2q7KAzaHX6zEaFSpH0tX4xltoxCvWrslNdnLRc/YEzWadDZ3F373Kv/zwF9i78kiisJsQSlOPYST1WA38fyzWPw+3qqBRS3d8pe50kbVuzzTAC/Yg4I9NHwuUEFaKbeq1UOR2UsGloL4dUH0fw6bzpVG230+jtJOpubaOexG3eq5234Q9VXvJ++lRde/KMdOHTSiTv39macN08xRkmY4eZ9b0/j5XYtiinTfblGU/UCGPjo1vrIzO6KCyH3VHhp5numb3IXuJGL9IW9OdHTSfkVrZVCicXGZ1LcSU5+lhXfTxVE2SeQ7kWqFPb36TSedTuMN+KXkmGWHK4+ldwTwNTpAZN55md7cbccG+f8fy0QUUcjlArrVLYDEqUaT5UChfbzz43tNMDsGBQcdLZ5UM3x5Hb2QF7MBXLsbjPnBQ7JWqx58L+tRXBnbN3+sCgQgLMnLTZ0aCDYtbjafUEd25i0JRf/zMBQlqND1Dr+VvUzUq78Xsy6aq1EtsqPXLvBwXduP/c+OfUbye7IvVPS680l/bWqpEiZKtWeY7YnWyBKnuR7QfWMTu5iwS7mNzP8lVd3Lbq8Vgk3RSdV78zxeUmPcY65iL90UUthRxq3jayH/GmVzKTvLZddOjau1hc8rgsOoqzE3XCrS2vurwlE+5UDNZ0nb5k2KX+qvQi0RodSSK9BdcCeyLNQ6/P3rO1SM9f1P69UVz9ERXYNVSbMZD6uOmt36hNWxk1V/YVynV9o2Zi3OQrSHSdLVwWrEmuhqnImUpOk4LXJIsmcFW+KsthfzrfGtXZd+nGPIvd2gewUStXqs3OXbaXlm07cuueAjupe4OOw3zpZN9klNbZLNKUvVhX+tFcTvKTYW2b/JhozqxUG3WCOiVTBiLdqGx3z4mf9Ve7hwrsMsmY9dkdmrg/x9/RFj9VA9Rh0Q94GMFwk6cRHibw4J9aRH/x4bnxi+tx1pdOE5HDf7Sd/EfTH8PaHHXPPGWRwWRWMfw9J+hmmB+S2GLTtDZ6OBla8EvAr1k/70dCXrrOh6+LSkJiNGfD6shxaG77BUvwwt6rtNFueCz5v7l8t+Nv9Lc92jXTHdwXwcaJsslyHF5nYaNiZba/WVry7T+h7k2/5OB+zl6QzFmiSnOrsqjsPejXcPNpgbWTOZ3IbVWc2jnmXZQyzC/Tr6biNjRTB/cL6Jr575doL6OmQRIr1bp23kbvU+FVGJeoWNphoinmw7WPYq8avS2qXnWLUhlbfJWHQncmRiu90QHaV8/2nvkvhslWjDYI0AwGR9Wc8HOt1dOT6TCOQbjetzpTrbqJrgttfBouyGlnfEFUUXVEaSjkn1HsPnzvtZLW6QUq1Vhc6yP79QT/067VYwz3vyFqsXs1H+Z/rc/bahv7q8G8KG3Km8LM8DZu3MtXhUSa9JFTESn6M5Senr117cxPoM24bfz9REllZ10DnW/y/Ba4ybcS080Yz+/yMyfIvIlthpm/td+XPiZ25iMy4X9CXoZ6RfS74NP0C9c4Xb04z0BmCrwu+EoYw7O9Cwx+7rQtLoJPmKD+7d1FAgQc4CPvM4ErGugCQiYQMiGTlYBMIGQCIRMImZC5epggc00//rdcc9IFn0bIvIaQL2ljrtqK8XbbOIUnpjp8c42/A39fuIsPgmkkM5E9cGYCn41MLgN/EWQlIBMImUDIBEImZAIhEwiZQMgEQiZkAtdIZgKuHPJYE2aBqMCAXE4DIRMygZAJhEwgZAIhEzKBkAmETCBkApvHqsCAt4JpJDPxWBNmgc9GJpeBXE4DIRMImUDIhEwgZAIhEwiZQMiETCBkAh9KZgKuHPJYE2aBqMCAXE4DIRMygZAJhEwgZAIhEzKBkAmETCBkAhtUYAEVGJAwC7wzmVwGcjkNhEwgZAIhEzKBkAmETCBkAiETMoGQCXwomQm4cshjTZgFogIDcjkNhEzIBEIm8PHwf5b0BsOogQ00AAAAAElFTkSuQmCC';

const log = logger.getLogger('component/ImageField');

const useStyles = makeStyles(theme => ({
    canvas: {
        borderColor: 'rgba(0, 0, 0, 0.23)',
        borderStyle: 'solid',
        borderWidth: '0px 1px 1px 1px',
        '&:hover': {
            borderColor: '#1a237e',
            '& fieldset': {
                borderColor: '#1a237e'
            }
        },
        '&:focus-within': {
            borderColor: theme.palette.primary.main,
            borderWidth: '0px 2px 2px 2px',
        }
    },
    titlebar: {
        '& fieldset': {
            borderRight: 'none',
            borderBottom: 'none',
            borderLeft: 'none'
        }
    }
}));

function ImageField(props) {
    const dimension = useDimension();
    const theme = useTheme();
    const defaultHeight = dimension.formControlHeight() * 2 + theme.spacing(2);
    const { className, multiple, disabled, readOnly, required, accept, fullHeight, fullWidth, objectFit, maxFileSize, maxTotalFileSize,
        helperText, zipFilename, allowDownload } = props;
    const style = {...props.style};
    const width = fullWidth ? '100%' : props.width;
    const height = fullHeight ? '100%' : props.height || defaultHeight;
    const classes = useStyles({width, height});
    const label = lang.isString(props.label) ? i18n.translate(props.label) : props.label;

    const [value, setValue] = useState([]);
    const [data, setData] = useState([]);
    const [index, setIndex] = useState(-1);
    const prompt = usePrompt();

    useEffect(() => {
        init();
    }, [props.value]);

    const init = async () => {
        let value;
        if(lang.isEmpty(props.value)) {
            value = [];
        } else if(lang.isArray(props.value)) {
            value = props.value;
        } else {
            value = [props.value];
        }
        const data = new Array(value.length);
        let currentIndex = lang.isNullOrUndefined(props.index) ? index : props.index;
        if(value.length===0) {
            currentIndex = -1;
        } else {
            currentIndex = Math.min(value.length-1, Math.max(0, currentIndex));
        }
        for (let i = 0; i < data.length; i++) {
            const source = value[i];
            data[i] = await fetch(source);
        }
        unstable_batchedUpdates(() => {
            setValue(value);
            setData(data);
            setIndex(currentIndex);
        });
    }

    const fetch = async (source) => {
        let descriptor;
        try {
            if(fileIO.isFileLike(source)) {
                descriptor = await downloader.load(source);
            } else {
                descriptor = await downloader.fetch(source);
            }
            const image = await imageIO.readAsImageDataURL(descriptor);
            return {descriptor, image};
        } catch(error) {
            log.error(`Failed to fetch the file(${source}).`, error);
            const name = i18n.translate('Failed to load');
            descriptor = fileIO.base64ToFile(UNKNOWN_IMAGE, { contentType: 'image/png', name});
            const image = await imageIO.readAsImageDataURL(descriptor)
            return {descriptor, image};
        }
    }

    const handleImageListChange = async event => {
        const { index } = event;
        const source = value[index];
        const currentData = [...data];
        const item = await fetch(source);
        currentData[index] = item;

        unstable_batchedUpdates(() => {
            setData(currentData);
            setIndex(index)
        });
    };

    const handleRemove = async () => {
        if(value.length===0) {
            return;
        }
        const currentValue = [...value];
        currentValue.splice(index, 1);
        const namedValue = multiple ? currentValue : (currentValue[0] || null);
        props.onChange && props.onChange({value: namedValue});

        const currentData = [...data];
        currentData.splice(index, 1);
        let currentIndex = (currentValue.length===0) ? -1 : Math.min(currentValue.length-1, index);
        if(currentIndex!==-1) {
            const source = value[currentIndex];
            const item = await fetch(source);
            currentData[currentIndex] = item;
        }
        unstable_batchedUpdates(() => {
            setValue(() => currentValue);
            setIndex(() => currentIndex);
            setData(() => currentData);
        });
    }

    const handleDownload = async () => {
        const item = data[index];
        const descriptor = item.descriptor;

        if(lang.isNullOrUndefined(descriptor)) return;

        await downloader.save(descriptor);
    }

    const handleDownloadAll = async event => {
        event.stopPropagation();

        const files = [];

        for(const source of value) {
            const file = await downloader.download(source);
            files.push(file);
        }

        const zip = await fileIO.zip(files);
        let filename;
        if(lang.isEmpty(zipFilename)) {
            const name = lang.isString(props.label) && !lang.isEmpty(props.label) ? i18n.translate(props.label) : props.name;
            const timestamp = time.format(time.now(), 'datetime');
            filename = lang.isEmpty(name) ? `${timestamp}.zip` : `${name}.zip`;
        } else {
            filename = zipFilename.endsWith(".zip") ? zipFilename : `${zipFilename}.zip`;
        }
        await fileIO.save(zip, filename);
    }

    const validateFileSizeConstraint = fileDescriptors => {
        let totalFileSize = data.reduce((sum, item) => {
            return sum+item.descriptor.size;
        }, 0);
        for(const fileDescriptor of fileDescriptors) {
            const name = fileDescriptor.name;
            if(fileDescriptor.size === 0) {
                throw new Error(i18n.translate(ZERO_FILE_SIZE_ERROR, {name}));
            }
            if(fileDescriptor.size > maxFileSize) {
                const size = numeral.format(maxFileSize, 'compact');
                const name = fileDescriptor.name;
                throw new Error(i18n.translate(MAX_FILE_SIZE_ERROR, {size, name}));
            }
            totalFileSize += fileDescriptor.size;
        }
        if(totalFileSize > maxTotalFileSize) {
            const size = numeral.format(maxTotalFileSize, 'compact');
            throw new Error(i18n.translate(MAX_TOTAL_FILE_SIZE_ERROR, {size}));
        }
    }

    const handleChange = async event => {
        const { descriptors, descriptor } = event;
        let currentValue, currentData, currentIndex = index, namedValue;

        try {
            validateFileSizeConstraint(event.descriptors)
        } catch(error) {
            prompt.alert(error.message);
            return;
        }

        if(multiple) {
            currentValue = [...value];
            currentData = [...data];
            if(currentIndex!==-1) {
                currentValue.splice(currentIndex, 0, ...descriptors);
                currentData.splice(currentIndex, 0, ...new Array(descriptors.length));
            } else {
                currentValue = currentValue.concat(descriptors);
                currentData = currentData.concat(new Array(descriptors.length));
                currentIndex = 0;
            }
            namedValue = currentValue;
        } else {
            currentValue = [descriptor];
            currentIndex = 0;
            currentData = new Array(0);
            namedValue = descriptor;
        }
        props.onChange && props.onChange({value: namedValue});

        if(currentIndex!==-1 && currentData[currentIndex]===undefined) {
            const source = currentValue[currentIndex];
            const item = await fetch(source);
            currentData[currentIndex] = item;
        }

        unstable_batchedUpdates(() => {
            setValue(currentValue);
            setData(currentData);
            setIndex(currentIndex);
        });
    }

    let title = '', images = [];
    if(index!==-1) {
        const { descriptor } = data[index];
        images = data.map(item=>item?.image);

        const filename = descriptor?.name
        title = lang.isEmpty(filename) ? i18n.translate('Unknown') : filename
    }

    if(readOnly) {
        style.pointerEvents = '';
    }

    const fileDropTitle = i18n.translate("Select a file");
    const fileDrop = (disabled || readOnly) ? null : (
        <FileDrop onChange={handleChange} multiple={multiple} accept={accept}
                  disabled={disabled || readOnly} maxFileSize={maxFileSize} >
            <Button disabled={disabled || readOnly} size="small" icon={<Icon fontSize={"1.2rem"} icon={outlineFolder} />} variant="icon" aria-label={fileDropTitle} title={fileDropTitle} />
        </FileDrop>
    );

    const downloadTitle = i18n.translate("Download the file")
    const downloadButton = disabled || !allowDownload ? null : (
        <Button size="small" onClick={handleDownload} icon={<Icon fontSize={"1.2rem"} icon={roundDownload} />} variant="icon"
                disabled={value.length===0}  aria-label={downloadTitle} title={downloadTitle} />
    );

    const downloadAllTitle = i18n.translate("Download all files")
    const downloadAllButton = disabled || !allowDownload || (value.length<=1) ? null : (
        <Button size="small" onClick={handleDownloadAll} icon={<Icon fontSize={"1.2rem"} icon={outlineFolderZip} />}  variant="icon"
                disabled={value.length<=1} aria-label={downloadAllTitle} title={downloadAllTitle} />
    );

    const removeTitle = i18n.translate("Remove the file");
    const removeButton = (disabled || readOnly) ? null : (
        <Button size="small" onClick={handleRemove} icon={<Icon fontSize={"1.2rem"} icon={roundClose} />} variant="icon"
                disabled={value.length===0}  aria-label={removeTitle} title={removeTitle} />
    );

    let endAdornment = (
        <Box display="flex" gap={1}  >
            {fileDrop}
            {downloadButton}
            {downloadAllButton}
            {removeButton}
        </Box>
    )

    let ariaLabel;
    if(props["aria-label"]) {
        ariaLabel = i18n.translate(props["aria-label"]);
    } else {
        ariaLabel = i18n.translate(lang.isString(props.label) ? props.label : '');
    }

    return (
        <FormControl className={clsx('appfuse-ImageField', className)} style={style} variant="outlined" required={required} fullWidth={fullWidth} disabled={disabled} >
            <Box className={classes.canvas} height={height} width={width} display="flex" flexDirection="column" overflow="hidden"
                 borderRadius={1} backgroundColor={theme.palette.background.default} >
                <Box display="flex" justifyContent="space-between">
                    <Box flexGrow={1}>
                        <InputLabel aria-label={ariaLabel} >{label}</InputLabel>
                        <OutlinedInput className={classes.titlebar} label={label} readOnly value={title} fullWidth endAdornment={endAdornment}  />
                    </Box>
                </Box>
                <FileDrop onChange={handleChange} multiple={multiple} accept={accept} fullWidth fullHeight
                          disabled={disabled || readOnly} maxFileSize={maxFileSize} >
                    <ImageList value={images} fullWidth fullHeight index={index}
                               onChange={handleImageListChange} transition="fade" objectFit={objectFit} />
                </FileDrop>
            </Box>
            <FormHelperText >{helperText}</FormHelperText>
        </FormControl>
    )
}

ImageField.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(FileDescriptor),
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.instanceOf(File),
            PropTypes.object,
        ]))
    ]),
    onChange: PropTypes.func,
    onError: PropTypes.func,
    name: PropTypes.string,
    readOnly: PropTypes.bool,
    readOnlyWhen: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    disabled: PropTypes.bool,
    disabledWhen: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    required: PropTypes.bool,
    status: PropTypes.string,
    placeholder: PropTypes.string,
    fullWidth: PropTypes.bool,
    fullHeight: PropTypes.bool,
    multiple: PropTypes.bool,
    accept: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    maxFileSize: PropTypes.number,
    maxTotalFileSize: PropTypes.number,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    objectFit: PropTypes.oneOf(['cover', 'contain', 'fill', 'none', 'auto', 'width', 'height']),
    helperText: PropTypes.string,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    "aria-label": PropTypes.string,
    allowDownload: PropTypes.bool,
    zipFilename: PropTypes.string
};

ImageField.defaultProps = {
    maxFileSize: 10*1000*1000,
    maxTotalFileSize: 50*1000*1000,
    allowDownload: true,
};

export default ImageField;